/**
 * Returns a capitalized string
 * @param value string to be formatted
 */
export const formatFirstCaseToUpper = (value, { fallback = null } = { fallback: null }) => {
    if (value === undefined)
        return fallback;
    return `${value.charAt(0).toUpperCase()}${value.slice(1).toLocaleLowerCase()}`;
};
/**
 * Generic string formatter. Currently supports uppercasing first case, adding a suffix and returning a dash if void
 * @param value object containing options to format a string
 * @param options.fallback fallback value that is returned when 'value' is undefined
 * @param options.suffix an optional suffix for the formatted return value
 */
export const formatString = (value, { fallback = null, firstToUpper, suffix } = {
    firstToUpper: false,
    suffix: '',
    fallback: null,
}) => {
    if (value === undefined)
        return fallback;
    const str = firstToUpper ? formatFirstCaseToUpper(value, { fallback: value }) : value;
    return `${str}${suffix}`;
};
/**
 * Format strings from kebab-case to camelCase
 * @param value string to be formatted
 * @returns formatted string
 */
export const kebabToCamelCase = (value, { fallback = null } = { fallback: null }) => {
    if (value === undefined)
        return fallback;
    return value.split('-').reduce((acc, word) => acc + (formatFirstCaseToUpper(word) || ''));
};
